/**
 * Created by admin on 11/21/17.
 */
export const EXTERNAL_ROOT_LINKS = {
  ROOT_REDHOTPIE: '',
};
export const EXTERNAL_LINKS = {
  REPORT_MESSAGE_MOBILE: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/Mobile/MemberProfile/Report.aspx?username={userName}&memberid={userId}&burl={backUrl}`,
  REPORT_MESSAGE_APP: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/Mobile/MemberProfile/Report.aspx?username={userName}&memberid={userId}`,
  REPORT_MESSAGE_DESKTOP: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/Help/ReportMemberForm.aspx`,

  REPORT_CONVERSATION_MOBILE: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/Mobile/MemberProfile/Report.aspx?username={userName}&memberid={userId}&burl={backUrl}`,
  REPORT_CONVERSATION_APP: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/Mobile/MemberProfile/Report.aspx?username={userName}&memberid={userId}`,
  REPORT_CONVERSATION_DESKTOP: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/Help/ReportMemberForm.aspx`,

  REPORT_USER_MOBILE: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/Mobile/MemberProfile/Report.aspx?username={userName}&memberid={userId}&burl={backUrl}`,
  REPORT_USER_APP: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/Mobile/MemberProfile/Report.aspx?username={userName}&memberid={userId}`,
  REPORT_USER_DESKTOP: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/Help/ReportMemberForm.aspx?username={userName}`,

  VIEW_PROFILE_MOBILE: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/Mobile/MemberProfile/OpenProfile.aspx?member={userId}&burl={backUrl}`,
  VIEW_PROFILE_APP: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/Mobile/MemberProfile/Report.aspx?username={userName}&memberid={userId}`,
  VIEW_PROFILE_DESKTOP: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/MemberProfile/ProfileViewPopup.aspx?memberid={userId}`,

  ALBUM_ADD_PHOTO_MOBILE: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/Mobile/MemberPhoto/?burl={backUrl}`,
  ALBUM_ADD_PHOTO_DESKTOP: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/Help/ReportMemberForm.aspx`,
  ALBUM_UPLOAD_PHOTO_MOBILE: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/Mobile/MemberPhoto/?burl={backUrl}`,
  ALBUM_UPLOAD_PHOTO_DESKTOP: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/MemberPhoto/`,
  VIEW_USER_PAGE: 'https://www.google.com.vn',

  UPGRADE_LINK_MOBILE: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/Mobile/Upgrade/DefaultNew.aspx?redir={backUrl}`,
  UPGRADE_LINK_DESKTOP: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/PayMemberships/upgrademembership.aspx`,
  UPGRADE_LINK_APP: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/Mobile/Upgrade/DefaultNew.aspx`,
  UPGRADE_LINK_IOS: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/PayMemberships/upgrademembership.aspx`,
  UPGRADE_LINK_ANDROID: '/rjsapp/authorize/upgrade?token={Token}&typeUpgrade={typeUpgrade}',
  DOWNLOAD_APP_ANDROID: 'http://play.google.com/store/apps/details?id=PACKAGEURL',
  DOWNLOAD_APP_IOS: 'http://itunes.apple.com/lb/app/PACKAGEURL',
  CREDIT_CARD_TRANSACTION: '/rjsapp/authorize/payment?token={Token}',
  FAKE_LINK: 'https://www.google.com.vn',

  OWNER_PROFILE_LINK_MOBILE: `${EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE}/Mobile/Upgrade/DefaultNew.aspx?redir={backUrl}`,
};

export const APP_SETTINGS = {
  INITIAL_CONV_DETAIL_MSG_COUNT: 100,
  INITIAL_CONV_DETAIL_MSG_COUNT_FOR_MOBILE: 25,
  MAXIMUM_PIN_CONVERSATION: 5,
  FACEBOOK_APP_ID: '229417623770081',
  // FACEBOOK_APP_ID: '349903098977561'
};

export const AUTHORIZE_MESSAGE_STATUS = {
  Authorised: 'Authorised',
  QuotaLimitGuestSender: 'QuotaLimitGuestSender',
  QuotaLimitPlatinumReceived: 'QuotaLimitPlatinumReceived',
  UnmatchingGuestToPlatinum: 'UnmatchingGuestToPlatinum',
  UnverifiedGuestReplyLimit: 'UnverifiedGuestReplyLimit',
  QuotaLimit: 'QuotaLimit',
  QuotaLimitMax: 'QuotaLimitMax',
  Unauthorised: 'Unauthorised',
  ReplyLimitReached: 'ReplyLimitReached',
  UnauthorisedSendToAustralia: 'UnauthorisedSendToAustralia',
  InboxLocked: 'InboxLocked',
  AccountAwaitingApproval: 'AccountAwaitingApproval',
  ReplyNotPossible: 'ReplyNotPossible',
  UsernameRejected: 'UsernameRejected',
  AccountVerificationRequired: 'AccountVerificationRequired',
  ReceiverRequiresVerification: 'ReceiverRequiresVerification',
  RequireVerification: 'RequireVerification',
  SenderRequiresReceiverVerification: 'SenderRequiresReceiverVerification',
  SenderBanned: 'SenderBanned',
};

export const SRC_TYPES = {
  APP: 'app',
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
};

export type TSrcType = (typeof SRC_TYPES)[keyof typeof SRC_TYPES];

export const TIME_OUT = {
  SHOW_LOADING_COMPLETE: 300,
  DELAY_LONG_PRESS: 300,
  SHOW_EMPTY_STATE_GROUP_CHAT: 10000,
  OPTION_1: 3000,
  ENTER_INPUT: 500,
};

export const LOGIN = {
  REACT_APP_USE_RHP_CACHED_TOKEN: true,
  REACT_APP_USE_XMPP_CACHED_TOKEN: true,
};

export const LIVE_STREAM_THUMNAIL = {
  WIDTH: 352,
  HEIGHT: 288,
  // WIDTH: 640,
  // HEIGHT: 480
};

export const MAX_COUNT_RETRY = 2;
